import { useNavigate, useLocation } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { useEstimate, estimateTotals } from "@/lib/estimate";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export default function EstimateBar() {
    const est = useEstimate();
    const navigate = useNavigate();
    const location = useLocation();
    if (!est || est.count === 0 || location.pathname === "/prices" || location.pathname === "/admin") return null;
    const { total } = estimateTotals(est.items);
    return (
        <button
            data-testid="view-estimate-bar"
            onClick={() => navigate("/prices#estimate")}
            className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 rounded-full bg-copper text-white font-mono uppercase tracking-[0.15em] text-[11px] px-6 py-3.5 shadow-2xl hover:bg-copper-bright transition-colors duration-300 flex items-center gap-3"
        >
            <ClipboardList size={14} />
            View Estimate ({est.count})
            <span className="text-white/80 normal-case tracking-normal">{inr(total)}</span>
        </button>
    );
}
